import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

function getISTDateTimeLocal() {
  const now = new Date();
  const offsetInMinutes = now.getTimezoneOffset();
  const localIST = new Date(now.getTime() - offsetInMinutes * 60000);
  return localIST.toISOString().slice(0, 16);
}

const groupInfo = {
  "group-1": [
    {
      label: "Truck No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      apiConfigKey: "getVehicleSuggestions",
      url: SERVER_URL + "/vehicle/",
      suggestionKeyword: "vehicle_no",
      suggestionKeywordForFetchApiArgs: "vehicle_no",
      suggestionSchema: {
        vehicle_id: "vehicle_id",
        vehicle_no: "vehicle_no",
        driver_name: "driver_name",
        owner_name: "owner_name",
        tds_rate: "tds_rate",
        pan_no: "pan_no",
      },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "driver_name",
      },
      toValidate: true,
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "station_from_name",
      },
    },
    {
      label: "From",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_from_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "booking_chalan_no",
      },
    },
    {
      label: "Challan No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "booking_chalan_no",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "trip_date",
      },
    },
    {
      label: "Dated",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "trip_date",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "delivery_article",
      },
    },
  ],
  "group-2": [
    {
      label: "Delivery Article",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "delivery_article",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "crossing_article",
      },
    },
    {
      label: "Crossing Article",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "crossing_article",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "total_article",
      },
    },

    {
      label: "Total Article",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_article",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "total_weight",
      },
    },
    {
      label: "Weight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "total_weight",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "gri_no",
      },
    },
    {
      label: "GRI No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "gri_no",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "delivery_maal_khata",
      },
    },
  ],
  "group-3": [
    {
      label: " Delivery Maal Khata A/C",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input-disabled",
      disabledField: true,
      name: "delivery_maal_khata",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "crossing_frieght",
      },
    },
    {
      label: "Crossing Freight A/C",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input-disabled",
      disabledField: true,
      name: "crossing_frieght",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "other_charge",
      },
    },
    {
      label: "Other",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      disabledField: true,
      name: "other_charge",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "debit_balance",
      },
    },
    {
      label: "Debit Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      disabledField: true,
      name: "debit_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "pay_to_driver",
      },
    },
  ],
  "group-4": [
    {
      label: "Truck Freight",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pay_to_driver",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "rebate_calculation",
      },
    },
    {
      label: "Labour A/C",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "rebate_calculation",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "deli_commission",
      },
    },
    {
      label: "Deli. Commision A/C",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "deli_commission",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "crossing_calculation",
      },
    },
    {
      label: "Crossing A/C",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "crossing_calculation",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "credit_balance",
      },
    },
    {
      label: "Credit Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      disabledField: true,
      name: "credit_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "final_balance",
      },
    },
    {
      label: "Final Balance",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      disabledField: true,
      name: "final_balance",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "save_button",
      },
    },
  ],
};

const dataObject = {
  station_from: "",
  station_from_name: "",
  vehicle_id: "",
  vehicle_no: "",
  created_from: "",
  remarks: "",
  created_by: "",
  challan_ids: [],
  booking_chalan_no: "",
  driver_name: "",
  total_weight: "",
  owner_name: "",
  trip_no: "",
  status: "",
  delivery_maal_khata: 0,
  crossing_frieght: 0,
  crossing_article: "",
  delivery_article: "",
  gri_no: 0,
  trip_date: "",
  debit_balance: "",
  credit_balance: "",
  final_balance: "",
  summary_of_account_no: "",
  manual_no: "",
  trip_id: "",
  deli_commission: 0,
  updated_by: 0,
  created_by: "",
  created_from: 0,
  fyear: "",
  id: "",
  last_summary_no: "",
  total_article: "",
  other_charge: "0",
  advance_bhada: "0",
  rebate: "0",
  rebate_calculation: "0",
  crossing_calculation: "",
  total_to_pay: "",
  pay_to_driver: "",
  date_of_summary: new Date(),

};

const tripChallanTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Challan No.", className: "text-center table-header" },
  { label: "Challan Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Total Pkgs", className: "text-center table-header" },
  { label: "Weight", className: "text-center table-header" },
  { label: "To Pay", className: "text-center table-header" },
  { label: "Paid", className: "text-center table-header" },
  { label: "To be Billed", className: "text-center table-header" },
];

const tripChallanTableItems = [
  {
    type: "text",
    name: "booking_chalan_no",
    label: "Bilty No",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "booking_chalan_date",
    label: "Bilty Date",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_from_name",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to_name",
    label: "Station To",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_pkgs",
    label: "Total Pkgs",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_weight",
    label: "Weight",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "total_to_pay",
    label: "To Pay",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "total_to_paid",
    label: "Paid",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "to_be_billed",
    label: "To Be Billed",
    className: "form-control-medium-col",
  },
];

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      console.log(groupInfo[group_name][i]);
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const popupInfo = {
  success_header: "Account Summary Saving Successful ",
  error_header: "Error In Account Summary Module ",
  success_title: "Account Summary is successfully created with the following info:-",
  field_label_success: "Account Summary No.",
  field_name_success: "summary_of_account_no",
  error_title: "Error in Account Summary module with the following info:-",
  field_label_error: "Error:",
};

export {
  groupInfo,
  groupNames,
  dataObject,
  tripChallanTableHeader,
  tripChallanTableItems,
  validate,
  popupInfo,
};
